import styled from "styled-components";
import breakpoints from "../utils/breakpoints";

export const Button = styled.button`
  background: #dbeaff;
  border: none;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 15px;
  color: #808080;
  cursor: pointer;
  font-family: "Public Sans";
  font-style: normal;
  font-weight: 700;

  &.style-dark {
    background: #2b6def;
    color: #fff;
    box-shadow: none;
  }

  &.style-disable {
    background: #e6eef9;
    color: #808080;
    opacity: 0.6;
    box-shadow: none;
  }

  &.style-active {
    background: #0045FF;
    border: 1px solid #2b6def;
    color: #fff;
  }

  &.style-historyBtn {
    background: #e6eef9;
    border-radius: 5px;
    font-family: "Public Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 15.3947px;
    line-height: 18px;
    color: #808080;
    display:flex;
    justify-content:space-between;
    width:120px;

    @media ${breakpoints.device.sm} {
      width: 95px;
      font-size: 11px;
    }
  }

  &.size-l {
    padding: 15px 25px;
    font-size: 20px;
  }

  &.scale {
    &:hover {
      transform: scale(1.05);
      transition: all 0.1s ease-in-out;
      box-shadow: rgb(0 0 0 / 8%) 0px 6px 10px;
    }
  }
`;

// clean the code and replace buttons

export const Close = styled.button`
    font-size: 21px;
    font-weight: bold;
    border: 4px solid white;
    background: white;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0px 7px 7px #0000000a;

    &:hover {
    color: #FFF;
    background: #2a6def;
    }

    &.size-s {
        width: 25px;
        height: 25px;
        font-size: 18px;
        box-shadow: 0px 1px 1px #0000000a;
        padding: 10px;
    }
`;

export const Loader = styled.div`
  border: 1px solid #fff;
  border-left-color: #185ee0;
  animation: loader-spin 1.2s infinite linear;
  position: relative;
  display: inline-block;
  vertical-align: top;
  border-radius: 50%;
  width: 20px;
  height: 20px;

  @keyframes loader-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
